export const tItemData = {
  "cont1":[
    {
      "imgSrc":"./images/main/trend/cont1/img_01.jpg",
      "cateName":"런스타",
      "itemName":"런스타 하이크 블랙",
      "itemPrice":"115,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_02.jpg",
      "cateName":"런스타",
      "itemName":"런스타 하이크 OX 블랙",
      "itemPrice":"109,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_03.jpg",
      "cateName":"런스타",
      "itemName":"런스타 하이크 OX 화이트",
      "itemPrice":"109,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_04.jpg",
      "cateName":"런스타",
      "itemName":"런스타 하이크 화이트",
      "itemPrice":"115,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_05.jpg",
      "cateName":"런스타",
      "itemName":"런스타 레거시 CX 에그렛",
      "itemPrice":"139,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_06.jpg",
      "cateName":"런스타",
      "itemName":"런스타 레거시 CX 미스틱 스카이",
      "itemPrice":"125,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_07.jpg",
      "cateName":"런스타",
      "itemName":"런스타 레거시 CX 유틸리티",
      "itemPrice":"125,000"
    },
    {
      "imgSrc":"./images/main/trend/cont1/img_08.jpg",
      "cateName":"런스타",
      "itemName":"런스타 레거시 첼시 CX 블랙",
      "itemPrice":"129,000"
    },
  ],
  "cont2":[
    {
      "imgSrc":"./images/main/trend/cont2/img_01.jpg",
      "cateName":"척70",
      "itemName":"척70 레더 블랙",
      "itemPrice":"115,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_02.jpg",
      "cateName":"척70",
      "itemName":"척70 클래식 블랙",
      "itemPrice":"95,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_03.jpg",
      "cateName":"척70",
      "itemName":"척70 스웨이드 블랙",
      "itemPrice":"109,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_04.jpg",
      "cateName":"척70",
      "itemName":"척70 레오파드 블랙",
      "itemPrice":"105,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_05.jpg",
      "cateName":"척70",
      "itemName":"척70 레더 후무스",
      "itemPrice":"109,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_06.jpg",
      "cateName":"척70",
      "itemName":"척70 클래식 블랙",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_07.jpg",
      "cateName":"척70",
      "itemName":"척70 포우 퍼 블랙",
      "itemPrice":"109,000"
    },
    {
      "imgSrc":"./images/main/trend/cont2/img_08.jpg",
      "cateName":"척70",
      "itemName":"척70 레더 문배스",
      "itemPrice":"115,000"
    },
  ],
  "cont3":[
    {
      "imgSrc":"./images/main/trend/cont3/img_01.jpg",
      "cateName":"원스타",
      "itemName":"콘스 원스타 프로 클래식 스웨이드 블루",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_02.jpg",
      "cateName":"원스타",
      "itemName":"콘스 원스타 프로 클래식 스웨이드 오렌지",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_03.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 클래식 스웨이드 시크릿 파인스",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_04.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 클래식 스웨이드 썬더",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_05.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 클래식 스웨이드 이터널 어스",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_06.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 클래식 스웨이드 팬텀 바이올렛",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_07.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 스웨이드 에그렛",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont3/img_08.jpg",
      "cateName":"원스타",
      "itemName":"원스타 프로 스웨이드 다크모스",
      "itemPrice":"99,000"
    },
  ],
  "cont4":[
    {
      "imgSrc":"./images/main/trend/cont4/img_01.jpg",
      "cateName":"플랫폼",
      "itemName":"척테일러 올스타 코브 코지 유틸리티 아이언 샴페인탄",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_02.jpg",
      "cateName":"플랫폼",
      "itemName":"척테일러 올스타 리프트 플랫폼 셰르파 비치스톤",
      "itemPrice":"95,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_03.jpg",
      "cateName":"플랫폼",
      "itemName":"척테일러 올스타 리프트 플랫폼 레더 & 셰르파 오리진 스토리",
      "itemPrice":"95,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_04.jpg",
      "cateName":"플랫폼",
      "itemName":"런스타 레거시 CX 파운데이셔널 레더 블랙",
      "itemPrice":"139,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_05.jpg",
      "cateName":"플랫폼",
      "itemName":"런스타 레거시 첼시 CX 블랙",
      "itemPrice":"116,100"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_06.jpg",
      "cateName":"플랫폼",
      "itemName":"척테일러 올스타 리프트 플랫폼 포우 모헤어 에그렛",
      "itemPrice":"99,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_07.jpg",
      "cateName":"플랫폼",
      "itemName":"척테일러 올스타 리프트 플랫폼 크래프티드 에볼루션 이터널 어스",
      "itemPrice":"89,000"
    },
    {
      "imgSrc":"./images/main/trend/cont4/img_08.jpg",
      "cateName":"플랫폼",
      "itemName":"런스타 레거시 CX 플랫폼 찬스 오브 레인",
      "itemPrice":"125,000"
    },
  ],
};